import axios from "axios";
import { CONST } from "../config/const";
import { ChartData } from "../component/chart/types";

export interface DataChatMessage {
  role: "user" | "assistant";
  content: string;
  chartData?: ChartData;
}

export async function postDataChatFeedback(
  id: number,
  feedback: 'good' | 'bad'
): Promise<void> {
  await axios.post(CONST.apiUrl2 + 'chatFeedback', {
    id,
    feedback,
    chat_log_type: 'ai_data_chat_log'
  });
}
